import { FileUploader, UploadFile } from '@davies-group/document-upload-lib';
import { useAppInsights } from '@davies-group/error-handling';
import { PageDivider } from '@davies-group/white-label-ui/ui';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { Box, Typography } from '@mui/material';

import { useDocumentUpload } from '../context/DocumentUploadContext';
import { Document, DocumentRequest } from '../models';
import { useUploadService } from '../services';

export type CustomerDocumentsComponentProps = {
    document: Document;
};

const CustomerDocumentsComponent = (props: CustomerDocumentsComponentProps) => {
    const { state, dispatch } = useDocumentUpload();
    const uploadService = useUploadService();
    const appInsights = useAppInsights();

    const onFileUploaded = (newFile: UploadFile) => {
        appInsights.info('hi');
        uploadService.uploadDocument(state.documentRequest.id, props.document.id, newFile.id, newFile.name).then((r) => {
            if (r) {
                const newFilesList = [...props.document.uploadedDocuments, newFile];
                onDocumentActionCompleted(newFilesList);
            }
        });
    };

    const onDocumentActionCompleted = (newFilesList: UploadFile[]): void => {
        const currentDocument = { ...state.documentRequest } as DocumentRequest;
        currentDocument.documents.forEach((x) => {
            if (x.id === props.document.id) {
                x.uploadedDocuments = newFilesList;
            }
        });
        dispatch({ type: 'updateDocumentRequest', payload: currentDocument });
    };

    const onFileRemoved = (fileId: string) => {
        uploadService.deleteDocument(state.documentRequest.id, props.document.id, fileId).then((r) => {
            if (r) {
                const newFilesList = props.document.uploadedDocuments.filter((i) => i.id !== fileId);
                onDocumentActionCompleted(newFilesList);
            }
        });
    };

    return (
        <Box data-testid="customer-documents" mb={2}>
            <Box px={4} mb={2}>
                <Typography color="secondary" align="left" variant="body1">
                    <ReactMarkdown>{props.document.instruction}</ReactMarkdown>
                </Typography>

                <FileUploader files={props.document.uploadedDocuments} maxTotalFiles={10} onFileUploaded={onFileUploaded} onFileRemoved={onFileRemoved} onFileRemoveFailed={(i) => appInsights.warn('Failed to remove file: ' + i, null)} />
            </Box>
            <PageDivider />
        </Box>
    );
};

export default CustomerDocumentsComponent;
